import React, { useState } from 'react'
import jwt_decode from "jwt-decode";
import { loadStripe } from "@stripe/stripe-js";
import {
    CardElement,
    Elements,
    useElements,
    useStripe,
} from "@stripe/react-stripe-js";
import { brandIcon } from '../../global/assets/Icons';
import { CustomerAccountIcons } from '../../global/assets/Icons';
import { IconButton } from '@mui/material';
import AddDeliveryAddress from '../../composed/deliveryaddress/AddDeliveryAddress';
import { getUrlPath } from "../../global/getUrl";
import YourPaymentMethod from '../../composed/yourpaymentmethod/YourPaymentMethod';
import GreetingUser from "../../global/greetingUser"
import { localStorageKeys } from '../../global/constants';
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);


const generateTabNames = (getUrlPath) => {
    // You have to create paths on app.js before coming here to add tan name
    switch (getUrlPath) {
        case '/customeraccount':
            return ('account');
        case '/customeraccount/deliveryaddress':
            return ('your addresses');
        case '/customeraccount/orders':
            return ('your orders');
        case '/customeraccount/cards':
            return ('your payments');
        case '/customeraccount/subscription':
            return ('subscription');
    }
}


const CustomerAccountMobile = () => {
    const { DEBUG_LOGOUT_POINT, TOKEN } = localStorageKeys;
    const [selectedBox, setBox] = useState(generateTabNames(getUrlPath()));
    const [isLoading, setIsLoading] = useState(false);
    const icons = [
        { src: '', label: 'your addresses', icon: CustomerAccountIcons.addresses, iconName: 'Addresses' },
        { src: '', label: 'your orders', icon: CustomerAccountIcons.orders, iconName: 'Orders' },
        { src: '', label: 'your payments', icon: CustomerAccountIcons.payments, iconName: 'Payments' },
        { src: '', label: 'subscription', icon: CustomerAccountIcons.subscription, iconName: 'Subscription' },
    ];



    const hasTokens = localStorage.getItem(TOKEN);
    let decodedToken = null
    if (hasTokens) {
        decodedToken = jwt_decode(hasTokens);

    }

    const firstName = decodedToken?.firstName || 'Guest';
    const lastName = decodedToken?.lastName || 'Guest'

    const DisplayName = () => {
        return <div style={{ fontFamily: 'Inter light', fontSize: '14px', letterSpacing: '0.4px' }}> {GreetingUser()}
            <a style={{ textTransform: 'capitalize', fontFamily: 'Inter Medium', fontSize: '14px', letterSpacing: '0.4px' }}> {lastName}</a></div>
    }


    const TriggerLoading = () => {
        setTimeout(() => {
            setIsLoading(false)
        }, 1000)
    }

    if (selectedBox === 'account') {
        return (
            <div div style={{ borderTop: '2px solid #FF7A28  ', }}>

                <div style={{ margin: '20px 0px 0px 17%', fontFamily: 'Inter Medium', fontSize: '14px' }}> {DisplayName()}</div>

                {selectedBox === 'account' && (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        margin: '10px 15% 10px 15%',
                        // justifyContent: 'space-around',
                    }}>
                        {icons.map((el) => (
                            <IconButton aria-label={el.label} size="small" onClick={() => { setBox(el.label); setIsLoading(true); TriggerLoading() }} key={el.label}>
                                <div style={{
                                    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                                    marginTop: '20px', border: '1px solid #e7e7e7', width: '75px', height: '90px', borderRadius: '5px'
                                }}>
                                    <img alt="" src={el.icon} height={35} marginTop={20}></img>
                                    <div style={{
                                        color: 'black',
                                        fontSize: '12px',
                                        marginTop: '5px',
                                        fontFamily: 'Roboto Medium',
                                        fontWeight: '500',
                                    }}>{el.iconName}</div>
                                </div>
                            </IconButton>

                        ))}
                    </div>

                )
                }
            </div>

        )
    }

    if (selectedBox === 'your addresses') {
        return (
            <>

                {isLoading ? <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    position: 'absolute',
                    top: '40%',
                    left: '40%',

                }}>...loading</div> :
                    <AddDeliveryAddress >
                        <button
                            onClick={() => {
                                setBox('account');
                            }}
                        >
                            Cancel
                        </button>
                    </AddDeliveryAddress>}

            </>

        )
    }

    if (selectedBox === 'your orders') {
        return (
            <>

                {isLoading ? <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    position: 'absolute',
                    top: '40%',
                    left: '40%',

                }}>...loading</div> : <button onClick={() => {
                    setBox('account');
                }}> Orders Component coming soon</button>


                }

            </>

        )
    }

    if (selectedBox === 'your payments') {
        return (
            <>

                {isLoading ? <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    position: 'absolute',
                    top: '40%',
                    left: '40%',

                }}>...loading</div> :

                    <Elements stripe={stripePromise}>
                        <YourPaymentMethod>
                            <button style={{ marginBottom: '10px' }} onClick={() => {
                                setBox('account');
                            }}>  Cancel</button>

                        </YourPaymentMethod>
                    </Elements>

                }

            </>

        )
    }

    if (selectedBox === 'subscription') {
        return (
            <>

                {isLoading ? <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    position: 'absolute',
                    top: '40%',
                    left: '40%',

                }}>...loading</div> : <button onClick={() => {
                    setBox('account');
                }}> subscription Component coming soon</button>


                }

            </>

        )
    }



}

export default CustomerAccountMobile